export const OPPORTUNITY_CONVERTED_TO_LEAD =
  'crm:opportunity-converted-to-lead';
export const notifyOpportunityConvertedToLead = () =>
  window.dispatchEvent(new Event(OPPORTUNITY_CONVERTED_TO_LEAD));
